module.exports = __webpack_public_path__ + "static/media/calc.421677dd.gif";